import React from 'react';

const SignoutPage = () => (
    <div>Wylogowano</div>
);
export default SignoutPage;